/* istanbul ignore file */
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _data from "../../data";
//import * as _helpers from "sb-helpers";
//import { customTags } from "sb-helpers";
import { ErrorBoundary } from "../../components";
/* Missing HTMLElement ref is "NULL" */
/* tslint:disable:no-null-keyword  no-non-null-assertion */
//done by "sb-helpers":
// make sure we have all the needed custom tags registered on the page
//_helpers.registerCustomTagsFromTagsCollection(customTags);
// this is needed to make all the helpers available in the exported library
//_helpers;
_data;
/**
 * BaseBlock class provides interface for communication between newly developed blocks and SBTech Responsive Application.
 */
export class BaseBlock {
    /**
     * @param {string} domId represent ID selector for an HTML element
     * @param {BaseBlockOptions} options providing interfaces for data, i18l, configuration
     */
    constructor(domId, options) {
        // error loggin for production code
        if (typeof domId !== "string") {
            throw new Error(`Wrong type of "domId" -> ${typeof domId}, expected to be of type STRING`);
        }
        this.domId = domId;
        this.dataProvider = null;
        this.isActive = false;
        this.isCustomLoaderProcessing = false;
        this.isShown = false;
        this.navHandler = options && options.navHandler || null;
        this.navigationPath = "";
        this.onBlockReady = {};
        this.options = options;
        this.panelId = options && options.panelId || "";
        this.parentBlock = null;
        // this.options.cms && BlocksCSSLinkManager.addCSSLinks(this.options.cms.CSSLinks);
    }
    // Ignoring React side effects during coverage tests
    /**
     * Activate method mounts react component instance to the DOM
     * Uses <ErrorBoundary /> component to wrap up components for propper error handling
     *
     * @param JSX.Element component
     * @returns BaseBlock instance
     */
    /* istanbul ignore next */
    activate(component) {
        this.beforeActivate();
        const domRef = document.getElementById(this.domId);
        if (domRef === null) {
            console.warn(`DOM element with id "${this.domId}" couldn't be located on the page.`);
        }
        if (domRef !== null && typeof component !== "undefined") {
            let comp = React.createElement(ErrorBoundary, null, component);
            ReactDOM.render(comp, domRef);
            this.isActive = true;
        }
        // this.options.cms && BlocksCSSLinkManager.createCSSLinks(this.options.cms.CSSLinks);
        this.afterActivate();
        return this;
    }
    // Ignoring React side effects during coverage tests
    /**
     * Deactivate method unmounts react component instance from the DOM
     * @returns BaseBlock instance
     */
    /* istanbul ignore next */
    deactivate() {
        this.beforeDeactivate();
        const domRef = document.getElementById(this.domId);
        if (domRef !== null) {
            ReactDOM.unmountComponentAtNode(domRef);
            this.isActive = false;
        }
        this.afterDeactivate();
        return this;
    }
    /**
     * afterActivate method is called after the react block is mounted in the DOM
     * @returns BaseBlock instance
     */
    afterActivate() {
        return this;
    }
    /**
     * afterDeactivate method is called after the react block is unmounted from the DOM
     * @returns BaseBlock instance
     */
    afterDeactivate() {
        return this;
    }
    /**
     * beforeActivate method is called before the react block is mounted in the DOM
     * @returns BaseBlock instance
     */
    beforeActivate() {
        if (this.dataProvider !== null && typeof this.dataProvider.activate === "function") {
            this.dataProvider.activate();
        }
        return this;
    }
    /**
     * beforeDeactivate method is called before the react block is unmounted from the DOM
     * @returns BaseBlock instance
     */
    beforeDeactivate() {
        if (this.dataProvider !== null && typeof this.dataProvider.deactivate === "function") {
            this.dataProvider.deactivate();
        }
        return this;
    }
    /**
     * getBlockContainer
     * @returns HTMLElement - element containing the react block
     */
    getBlockContainer() {
        return document.getElementById(this.domId);
    }
    /**
     * getPanel returns panel when react block is inside the responsive application
     * @returns PanelInstance - not typed in the react lib
     */
    getPanel() {
        // PanelID -> compatibility with mobile app
        return this.navHandler.Panels[this.panelId || this["PanelID"]];
    }
    /**
     * getPanelPosition position in the layout
     * @returns Position - not typed in the react lib
     */
    getPanelPosition() {
        return this.getPanel().Position;
    }
    /**
     * getTabLabel method not used in the react blocks - ensures backward compatibility
     * @returns BaseBlock instance
     */
    getTabLabel() {
        return this;
    }
    /**
     * hidePreloader method not used in the react blocks - ensures backward compatibility
     * @returns BaseBlock instance
     */
    hidePreloader() {
        // if (this && !this.isCustomLoaderProcessing) {
        //     var preloader = document.getElementById('preloader');
        //     Dom.hideElement(preloader);
        // }
        return this;
    }
    /**
     * hideBlockLoader method not used in the react blocks - ensures backward compatibility
     * @returns BaseBlock instance
     */
    hideBlockLoader() {
        return this;
    }
    /**
     * init method not used in the react blocks - ensures backward compatibility
     * @returns BaseBlock instance
     */
    init() {
        return this;
    }
    /**
     * destroy clear all stored parameter. Block cannot be activated anymore once the instance is destroyed.
     * @returns BaseBlock instance with nullified fields
     */
    destroy() {
        this.domId = "";
        this.panelId = "";
        this.isShown = false;
        this.isActive = false;
        this.options = undefined;
        this.navigationPath = "";
        this.navHandler = undefined;
        this.parentBlock = undefined;
        this.onBlockReady = undefined;
        this.dataProvider = undefined;
        this.isCustomLoaderProcessing = false;
        return this;
    }
    /**
     * isDesktop method not used in the react blocks - ensures backward compatibility
     * @returns BaseBlock instance
     */
    isDesktop() {
        // return Application.deviceType.isDesktop();
        return this;
    }
    /**
     * Switches view to another block
     *
     * @param {any[]} params Function arguments as array
     */
    navigateTo(...params) {
        if (params.length > 0) {
            for (let i = 0; i < params.length; i += 1) {
                if (params[i] === null || params[i] === undefined) {
                    params[i] = 0;
                }
                else if (!isNaN(params[i])) {
                    // Prevent parsing to number in blocks because Application navigation passes all parameters as string
                    params[i] = Number(params[i]);
                }
            }
            this.navHandler.navigateTo(this.panelId, this.getPanel().isSidePanel(), params, this.navigationPath);
            this.navigationPath === "";
        }
    }
    /**
     * onBlockHide method sets property isShown, called when block is hidden
     * @returns BaseBlock instance
     */
    onBlockHide() {
        this.isShown = false;
        return this;
    }
    /**
     * onBlockHide method sets property isShown called when block is shown
     * @returns BaseBlock instance
     */
    onBlockShow() {
        this.isShown = true;
        return this;
    }
    /**
     * onPanelEnter method called when user navigates to a panel
     * @returns BaseBlock instance
     */
    onPanelEnter() {
        return this;
    }
    /**
     * onPanelLeave method called when user navigates away from panel
     * @returns BaseBlock instance
     */
    onPanelLeave() {
        return this;
    }
    /**
     * Sets navigation path to block instance
     *
     * @param {string} path Navigation path to block instance
     */
    setNavigationPath(path) {
        this.navigationPath = path;
        return this;
    }
    /**
     * Sets dynamic configurations of data provider for pulling data
     *
     * @param {any[]} params Function arguments as array
     */
    setParams(...params) {
        if (this.dataProvider !== null && typeof this.dataProvider.setParams === "function") {
            /* istanbul ignore next */
            this.dataProvider.setParams.apply(this.dataProvider, params);
        }
    }
    /**
     * showPreloader not used in react blocks, here for consistency
     * @returns BaseBlock instance
     */
    showPreloader() {
        // if (!this.isCustomLoaderProcessing) {
        //     var preloader = document.getElementById('preloader');
        //     Dom.showElement(preloader);
        // }
        return this;
    }
    /**
     * whenBlockIsReady no used in react blocks, here for consistency
     * @returns BaseBlock instance
     */
    whenBlockIsReady() {
        // if ((this.htmlContainer || this.TabsContainerElem) && this.onBlockReady) {
        //     executeEvents(this.onBlockReady, this.ID,
        //         {
        //             htmlContainerID: this.constructor.name
        //         });
        // }
        return this;
    }
}
//# sourceMappingURL=BaseBlock.js.map